import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
// import { DocumentsFormLogic } from "../../../create-loan/documents/DocumentsForm";
// import { useDispatch } from "react-redux";
// import { isOrigUser } from "../../../utils/AccessManagement";
import { getDrawDetailsByDrawId } from "../../../stores/drawRequest/drawRequest.action";
import { useDrawsStyles } from "../Draws.styles";

// const DocumentsFormLogic = lazy(() =>
//   import("../../../create-loan/documents/DocumentsForm").then(module => ({
//     default: module.DocumentsFormLogic
//   }))
// );

export const DrawDocsButtonsWrapper = (props: {
  drawId: any;
  loanId: any;
  disable: boolean;
  handleBudgeReconcileClick: any;
  budgetReconDisable: boolean;
  dispatch: any;
  isOrig: boolean;
  setSnackBarMsg: (msg: { messageType: "success" | "info" | "warning" | "error" | undefined; message: string }) => void;
  setOpenSnackBar: (open: boolean) => void;
}) => {
  //   const isOrig = isOrigUser();
  // const dispatch = useDispatch();
  const classes = useDrawsStyles();
  const [isRefetching, setIsRefetching] = useState<boolean>(false);
  const {
    drawId,
    loanId,
    disable,
    handleBudgeReconcileClick,
    budgetReconDisable,
    dispatch,
    isOrig,
    setSnackBarMsg,
    setOpenSnackBar
  } = props;

  //   const [purchasedDocsToPass, setPurchasedDocsToPass] = useState<any[]>([]);
  //   const [isDocsLoading, setIsDocsLoading] = useState<boolean>(true);

  const tabRedirect = (params: string) => {
    // navigate(`/drawDetails/${loanId}/${drawId}/${params}`);
    window.open(`/drawDetails/${loanId}/${drawId}/${params}`, "_blank");
  };

  const handleDocumentTaggingClick = async () => {
    setIsRefetching(true);
    try {
      // Refetch draw documents to get latest primary document markings
      await dispatch(getDrawDetailsByDrawId(drawId, isOrig, false, false));
      // Wait a bit for Redux store to update
      await new Promise(resolve => setTimeout(resolve, 500));
      // Open document tagging page with fresh data
      tabRedirect("documentTagging");
    } catch (error) {
      console.error("Error refetching draw documents:", error);
      setSnackBarMsg({
        messageType: "warning",
        message: "Failed to refresh documents. Opening page with existing data."
      });
      setOpenSnackBar(true);
      // Still navigate even if refetch fails (graceful degradation)
      tabRedirect("documentTagging");
    } finally {
      setIsRefetching(false);
    }
  };

  //   const docsListToPass = {
  //     docsLoaded: true,

  //     files: purchasedDocsToPass,
  //     failedUploads: 0,
  //     successfulUploads: purchasedDocsToPass.length
  //   };
  return (
    <>
      <Button
        variant="contained"
        className={classes.docsImportBtn}
        style={{ marginRight: "10px", marginTop: "4px" }}
        disabled={disable || isRefetching}
        onClick={handleDocumentTaggingClick}
        startIcon={isRefetching ? <CircularProgress size={16} color="inherit" /> : undefined}
      >
        Documents Tagging
      </Button>
      <Button
        variant="contained"
        className={classes.docsImportBtn}
        style={{ marginRight: "10px", marginTop: "4px" }}
        disabled={budgetReconDisable || disable}
        onClick={() => {
          handleBudgeReconcileClick(tabRedirect);
        }}
      >
        Budget Reconciliation
      </Button>
    </>
  );
};
